<button
  class="flex items-center gap-3 w-full px-5 py-6 bg-white/[0.08] border-b border-white/[0.08] cursor-pointer transition-colors hover:bg-white/[0.13]"
  (click)="navigateToProfile()">
  <div class="w-12 h-12 rounded-full bg-white/[0.15] overflow-hidden flex items-center justify-center flex-shrink-0">
    <svg class="w-full h-full text-white/60" fill="currentColor" viewBox="0 0 24 24">
      <path
        d="M24 20.993V24H0v-2.996A14.977 14.977 0 0112.004 15c4.904 0 9.26 2.354 11.996 5.993zM16.002 8.999a4 4 0 11-8 0 4 4 0 018 0z" />
    </svg>
  </div>
  <div class="flex flex-col items-start flex-1 min-w-0">
    <span class="text-lg font-semibold text-white truncate max-w-[140px]">{{ nome }}</span>
    <span class="text-sm text-white/55 mt-px">{{ papel }}</span>
  </div>

</button>